import axios from 'axios'

export default {
    getPrayerDataSource(params){
        return axios.get('/prayer/datasource', {params})
            .then(response => {
                return response.data
            })
    },   
    deactivate(id){
        return axios.post('/prayer/' + id + '/response')
            .then(response => {
                return response.data
            })
    },
    getPrayerbyID(id){
        return axios.get('/prayer/' + id)
            .then(response => {
                return response.data
            })
    },  
}